export default {
  'validators.tinNumberFormat':
    'Please enter a valid TIN number (e.g. 123-456-789-001 or 123-456-789-12345)',
  'validators.phoneNumberFormat':
    'Please enter a valid Philippine mobile number',
  // 2026-09-28 表单规则文案纳入内置 locales(此前 formRules.ts 硬编码中文)
  'validators.emailFormat': 'Please enter a valid email address',
  'validators.englishOnly': 'Only English letters are allowed',
  'validators.numberOnly': 'Only digits are allowed',
  'validators.alphanumeric': 'Only letters and digits are allowed',
  'validators.alphanumericDash': 'Only letters, digits and hyphens are allowed',
  'validators.passwordPattern':
    'Password must be 6-20 characters, contain both letters and digits, and no Chinese characters',
};
